/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Forward Icon component.
 */
export const MaterialForwardIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19483)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M7.00003 18.1333L8.8667 20L16.8667 12L8.8667 4L7.00003 5.86666L13.1334 12L7.00003 18.1333Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19483'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialForwardIcon;
